import { Component } from '@angular/core'
import { Constants } from 'src/app/constants'
import { HomeService } from 'src/services/home/home.service';

@Component({
    selector : 'app-acerca-de',
    templateUrl: './acerca-de.component.html',
    styleUrls: ['./acerca-de.component.css']
})
export class AcercaDeComponent{
    titulo = Constants.ACERCA_DE;
    currentYear = new Date().getFullYear();
    public appData : any ;

    acercaDe = {
        applicationName :'',
        version: '',
        build : '',
        webSite:'',
        certificate:'',
        provider:''
    }

    constructor(
        private HomeService:HomeService
    ){
        this.appData = this.HomeService.getEnvironment();
        this.acercaDe = this.appData.licenseData.about;
    }

    openHelpDesk(url: string) {
        window.open(url, '_blank'); 
    }
}